<template>
  <div>
    <CardAlert color="#E65100">
      <v-toolbar
        dark
        :style="{ background: '#E65100', color: 'white' }"
        shaped
        max-width="344"
        dense
      >
        <v-autocomplete
          prepend-inner-icon="search"
          v-model="selectedGroup"
          :items="groups"
          class="ml-2"
          flat
          hide-no-data
          hide-details
          :label="'Select Group'"
          solo-inverted
          @change="getSelectedGroup()"
        ></v-autocomplete>
        <v-btn icon @click="openGlobalDialogSlot()">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </CardAlert>

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateGroup
        @group-created="getNewGroup"
        @exist="title = 'Item Exist'"
      ></CreateGroup>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import CreateGroup from "@/components/SMS/CreateGroup.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  name: "Groups",
  components: { GlobalDialogSlot, CreateGroup, CardAlert },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-all-sms-groups", this.getAccessToken)
      .then((groups) => {
        this.groups = [
          { text: "Staff", value: { name: "Staff", id: 1000000 } },
          {
            text: this.getCompanyLabels.client + "s",
            value: { name: this.getCompanyLabels.client + "s", id: 1000001 },
          },
          { text: "Users", value: { name: "Users", id: 1000002 } },
        ];
        groups.forEach((group) => {
          this.groups.push({
            text: `${group.name}`,
            value: group,
          });
        });
        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    title: "Create Group",
    groups: [],
    selectedGroup: null,
    dialog: false,
  }),
  methods: {
    getSelectedGroup() {
      this.$emit("group-selected", this.selectedGroup);
    },
    openGlobalDialogSlot() {
      this.dialog = true;
    },
    getNewGroup(group) {
      this.groups.push({
        text: `${group.name}`,
        value: group,
      });
      this.selectedGroup = group;
      this.$emit("group-selected", this.selectedGroup);
      this.dialog = false;
    },
  },
};
</script>

<style></style>
